import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppStatsPage } from './app-stats';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";
import {ComponentsModule} from "../../components/components.module";
import {NgCircleProgressModule} from "ng-circle-progress";

@NgModule({
  declarations: [
    AppStatsPage,
  ],
  imports: [
    IonicPageModule.forChild(AppStatsPage),
    PipesModule,
    DirectivesModule,

    ComponentsModule,
    NgCircleProgressModule
  ],
})
export class AppStatsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-stats/app-stats.module.ts